import React, { useState } from "react";

function LoginModal({ isOpen, onClose, onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !email.includes("@")) {
      alert("Por favor, insira um email válido");
      return;
    }

    if (!password) {
      alert("Por favor, insira uma palavra-passe");
      return;
    }

    setIsLoading(true);

    // Simulate API call delay
    setTimeout(() => {
      // Fake login - always succeeds for valid emails
      const userData = {
        email: email,
        name: email.split("@")[0], // Use email prefix as name
        sessionId: `session_${Date.now()}_${Math.random()
          .toString(36)
          .substring(2, 11)}`,
      };

      // Save to localStorage
      localStorage.setItem("ai_agent_session_id", userData.sessionId);
      localStorage.setItem("ai_agent_user_email", userData.email);
      localStorage.setItem("ai_agent_user_name", userData.name);

      setIsLoading(false);
      onLogin(userData);
      onClose(); // Close modal after successful login
    }, 500);
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🔐 Login</h2>
          <button
            className="close-button"
            onClick={handleClose}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="exemplo@exemplo.com"
                required
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Palavra-passe:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Palavra-passe"
                required
                disabled={isLoading}
              />
            </div>

            <button type="submit" disabled={isLoading} className="login-button">
              {isLoading ? "A fazer login..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
